
import React, { useState } from 'react';
import { Col, Container, Row } from 'reactstrap';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs/Breadcrumbs';
import ExhibitorTypeList from './ExhibitorTypeList';
import ExhibitorTypeModal from './ExhibitorTypeModal';
import { ExhibitorType } from './types';

const ExhibitorTypeContainer = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<ExhibitorType | null>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(false);

  const handleOpenAdd = () => {
    setSelectedItem(null);
    setModalOpen(true);
  };

  const handleOpenEdit = (item: ExhibitorType) => {
    setSelectedItem(item);
    setModalOpen(true);
  };

  const handleSuccess = () => {
    setModalOpen(false);
    setRefreshTrigger(prev => !prev); 
  };

  return (
    <>
      <Breadcrumbs mainTitle="Exhibitor Types" parent="Core Settings" />
      <Container fluid>
        <Row>
          <Col md="12">
            <ExhibitorTypeList
              onAdd={handleOpenAdd}
              onEdit={handleOpenEdit}
              refresh={refreshTrigger}
            />
          </Col>
        </Row>
        <ExhibitorTypeModal
          isOpen={modalOpen}
          toggle={() => setModalOpen(false)}
          onSuccess={handleSuccess}
          initialData={selectedItem}
        />
      </Container>
    </>
  );
};

export default ExhibitorTypeContainer;
